<template>
  <form-wizard
    color="#ce7b2c"
    :title="$t('master.request_new_master')"
    :subtitle="null"
    :finish-button-text="$t('site.finish')"
    :back-button-text="$t('site.back')"
    :next-button-text="$t('site.next')"
    @on-complete="formSubmitted"
  >
    <b-card>
      <!-- attach_master_file -->
      <tab-content :title="$t('master.attach_master_file')">
        <b-row>
          <b-col md="12">
            <!-- .department -->
            <b-form-group
              id="input-group-30"
              :label="$t('master.attach_master_file')"
              label-for="input-30"
            >
              <b-form-file
                v-model="newItem.masterFile"
                :placeholder="$t('master.attach_master_file')"
                drop-placeholder="Drop file here..."
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <!-- .department -->
            <b-form-group
              id="input-group-30"
              :label="$t('master.master_body')"
              label-for="input-30"
            >
              <ckeditor
                :config="{ contentsLangDirection: 'rtl',versionCheck : false }"
                v-model="newItem.body"
                :placeholder="$t('master.master_body')"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </tab-content>
      <!-- rules_instructions -->
      <tab-content :title="$t('master.rules_instructions')">
        <b-row style="min-height: 250px">
          <b-col lg="12">
            <b-tabs vertical nav-wrapper-class="nav-vertical">
              <b-tab
                :title="type.name"
                v-for="type in masterType"
                :key="type.id"
              >
                <b-row>
                  <b-col lg="12">
                    <b-tabs>
                      <b-tab :title="$t('master.instructions')">
                        <b-card-text v-html="type.instructions"> </b-card-text>
                      </b-tab>
                      <b-tab :title="$t('master.rules')">
                        <b-row>
                          <b-col lg="12">
                            <div class="row">
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label>{{
                                    $t("master.minimum_words")
                                  }}</label>
                                  <div class="input-group">
                                    <h6 class="d-inline-block">
                                      <span class="badge badge-primary">{{
                                        type.minimum_words
                                      }}</span>
                                    </h6>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label>{{
                                    $t("master.maximum_words")
                                  }}</label>
                                  <h6 class="d-inline-block">
                                    <span class="badge badge-primary">{{
                                      type.maximum_words
                                    }}</span>
                                  </h6>
                                </div>
                              </div>
                            </div>

                            <div class="row">
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label>{{
                                    $t("master.minimum_references")
                                  }}</label>
                                  <div class="input-group">
                                    <h6 class="d-inline-block">
                                      <span class="badge badge-primary">{{
                                        type.minimum_references
                                      }}</span>
                                    </h6>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label>{{
                                    $t("master.maximum_references")
                                  }}</label>
                                  <h6 class="d-inline-block">
                                    <span class="badge badge-primary">{{
                                      type.maximum_references
                                    }}</span>
                                  </h6>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label>{{
                                    $t("master.minimum_quotation")
                                  }}</label>
                                  <div class="input-group">
                                    <h6 class="d-inline-block">
                                      <span class="badge badge-primary">{{
                                        type.minimum_quotation
                                      }}</span>
                                    </h6>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-6">
                                <div class="form-group">
                                  <label>{{
                                    $t("master.maximum_quotation")
                                  }}</label>
                                  <h6 class="d-inline-block">
                                    <span class="badge badge-primary">{{
                                      type.maximum_quotation
                                    }}</span>
                                  </h6>
                                </div>
                              </div>
                            </div>
                          </b-col>
                        </b-row>
                      </b-tab>
                    </b-tabs>
                  </b-col>
                </b-row>
              </b-tab>
            </b-tabs>
          </b-col>
        </b-row>
      </tab-content>
      <!-- personal details -->
      <tab-content :title="$t('master.choose_master_type')">
        <b-col md="12" style="min-height: 250px">
          <!-- .department -->
          <b-form-group
            id="input-group-30"
            :label="$t('master.master_type')"
            label-for="input-30"
          >
            <v-select
              dir="rtl"
              id="input-30"
              v-model="newItem.type_id"
              :reduce="(item) => item.id"
              label="name"
              :options="masterType"
            />
          </b-form-group>
        </b-col>
      </tab-content>
      <!-- address -->
      <tab-content :title="$t('master.choose_supervisors')">
        <b-col md="12" style="min-height: 250px">
          <!-- .department -->
          <b-form-group
            id="input-group-30"
            :label="$t('master.choose_supervisors')"
            label-for="input-30"
          >
            <v-select
              dir="rtl"
              id="input-30"
              v-model="newItem.teachers_ids"
              :reduce="(item) => item.id"
              label="full_name"
              :options="teachers"
              taggable
              multiple
            />
          </b-form-group>
        </b-col>
      </tab-content>
      <!-- social link -->
      <tab-content :title="$t('master.choose_title')">
        <b-col md="12" style="min-height: 250px">
          <!-- .department -->
          <b-form-group
            id="input-group-30"
            :label="$t('master.choose_title')"
            label-for="input-30"
          >
            <b-form-input
              v-model="newItem.title"
              :placeholder="$t('master.choose_title')"
            />
          </b-form-group>
        </b-col>
      </tab-content>

      <!-- upload_master_plan -->
      <tab-content
        :title="$t('master.upload_master_plan')"
        style="min-height: 250px"
      >
        <b-col md="12">
          <!-- .department -->
          <b-form-group
            id="input-group-30"
            :label="$t('master.upload_master_plan')"
            label-for="input-30"
          >
            <b-form-file
              v-model="newItem.planFile"
              :placeholder="$t('master.upload_master_plan')"
              drop-placeholder="Drop file here..."
            />
          </b-form-group>
        </b-col>
        <b-col md="12">
          <!-- .department -->
          <b-form-group
            id="input-group-30"
            :label="$t('master.upload_master_plan')"
            label-for="input-30"
          >
            <ckeditor
              :config="{ contentsLangDirection: 'rtl' ,versionCheck : false}"
              v-model="newItem.plan"
              :placeholder="$t('master.upload_master_plan')"
            />
          </b-form-group>
        </b-col>
      </tab-content>
    </b-card>
  </form-wizard>
</template>

<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import vSelect from "vue-select";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import MasterTypeController from "@/Controllers/MasterTypeController";
import UsersController from "@/Controllers/UsersController";
import Controller from "@/Controllers/MastersController";

export default {
  components: {
    FormWizard,
    TabContent,

    vSelect,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
  },
  data() {
    return {
      masterType: [],
      newItem: {},
      teachers: [],
    };
  },
  async created() {
    this.masterType = await new MasterTypeController().GetAll();
    this.teachers = await new UsersController().GetAll({ type: "teacher" });
    // this.teachers = await new UsersController().GetAll({type:'teacher'});
  },
  methods: {
    async formSubmitted() {
      await new Controller().RequestNewMaster(this.newItem);
      this.$router.push({ name: "Masters" });
    },
  },
};
</script>
